module.exports = __webpack_public_path__ + "static/PAKDReel-671ea6558836c939a0cbcb25f6771bba.mp4";